export const mutations = {
  MutationOnOpenBanner(state) {
    state.isOpen = true;
  },
  MutationOnCloseBanner(state) {
    state.isOpen = false;
  },
  MutationDataBanner(state, _input) {
    state.data = _input;
  },
  MutationBannerRestate(state) {
    state.isOpen = false;
    state.t_header = null;
    state.t_content = null;
    state.data = {};
  },
};
